import {
  Collapse,
  ExpandMoreRoundedIcon,
  Flex,
  IconButton,
  MoreMenuIconButton,
  Rotate,
  Text,
  type FlexProps,
  DeleteOutlineIcon,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

export interface PartSectionProps extends FlexProps {
  partData: {
    id: string;
    name: string;
    totalQuestions: number;
  };
  handleDeleteMenu: (id: string) => void;
}

export default function PartSection(props: Readonly<PartSectionProps>) {
  const { partData, handleDeleteMenu, children, ...restProps } = props;
  const [isOpen, { toggle }] = useDisclosure(true);
  const partTotalQuestions = partData.totalQuestions;

  return (
    <Flex
      {...restProps}
      sx={{
        flexDirection: 'column',
        pb: (theme) => theme.spacing(4),
        ...restProps?.sx,
      }}
    >
      <Flex
        sx={(theme) => ({
          alignItems: 'center',
          py: theme.spacing(2.5),
          pl: theme.spacing(3),
          pr: theme.spacing(4),
          borderRadius: theme.shape.rounded(2),
          border: '1px solid',

          borderColor: (theme) => (isOpen ? theme.palette.primary.main : theme.palette.grey[300]),
          bgcolor: (theme) =>
            isOpen ? theme.palette.primary.main : theme.palette.background.paper,
        })}
      >
        <IconButton onClick={toggle}>
          <Rotate in={isOpen}>
            <ExpandMoreRoundedIcon />
          </Rotate>
        </IconButton>
        <Flex
          sx={(theme) => ({
            flex: 1,
            gap: theme.spacing(2),
          })}
        >
          <Text variant='h5'>{partData.name}</Text>
        </Flex>
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(2),
            p: theme.spacing(0.5, 2, 0.5, 6),
            alignItems: 'center',
          })}
        >
          <Text variant='h5'>จำนวน</Text>
          <Text variant='h5'>{partTotalQuestions}</Text>
          <Text variant='h5'>ข้อ</Text>
        </Flex>

        <MoreMenuIconButton
          options={[
            {
              label: 'Remove',
              icon: <DeleteOutlineIcon sx={(theme) => ({ color: theme.palette.error.main })} />,
              sx: (theme) => ({ color: theme.palette.error.main }),
              onClick: () => handleDeleteMenu(partData.id),
            },
          ]}
        />
      </Flex>
      <Collapse in={isOpen}>{children}</Collapse>
    </Flex>
  );
}
